import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-modifica-campo',
	templateUrl: './modifica-campo.component.html',
	styleUrls: ['./modifica-campo.component.css']
})
export class ModificaCampoComponent implements OnInit {

	@Input() data : any;
	@Input() writePermission : boolean;

	dataSource : any;
	dataTmp : any;
	dataKeys : any[] = [];

	@Output() create = new EventEmitter();
	@Output() modify = new EventEmitter();
	@Output() delete = new EventEmitter();

	constructor(
		private dataService : DataService
		) { }

	ngOnInit() {
	}

	ngOnChanges(changes: any) {
		if (changes.data) {
			this.dataSource = _.cloneDeep(this.data);
			this.dataTmp = _.cloneDeep(this.data);
			this.dataKeys = Object.keys(this.data);
			console.log('dataSource',this.dataSource);
			console.log('dataTmp',this.dataTmp);
			console.log('dataKeys',this.dataKeys);
		}
	}

	edit() {

	}

	commit() {

	}

	discard() {

	}

	remove() {

	}

	reset() {
		this.dataTmp = _.cloneDeep(this.dataSource);
	}

}
